import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import humanTime from 'flarum/common/helpers/humanTime';
import icon from '../../common/helpers/icon';
import classList from 'flarum/common/utils/classList';
import ItemList from 'flarum/common/utils/ItemList';
import app from 'flarum/forum/app';
export default class BlogOverviewItem extends Component {
  titleItems() {
    var _article$blogMeta, _article$blogMeta$isP, _article$blogMeta2, _article$blogMeta2$is;
    const article = this.attrs.article;
    const items = new ItemList();
    items.add('title', m('[', null, article.title()), 100);
    if ((_article$blogMeta = article.blogMeta()) != null && (_article$blogMeta$isP = _article$blogMeta.isPendingReview) != null && _article$blogMeta$isP.call(_article$blogMeta) || article.isHidden()) {
      items.add('hidden', icon('fas fa-eye-slash', {
        class: 'BlogList-item-hidden'
      }), 80);
    }
    if ((_article$blogMeta2 = article.blogMeta()) != null && (_article$blogMeta2$is = _article$blogMeta2.isPendingReview) != null && _article$blogMeta2$is.call(_article$blogMeta2)) {
      items.add('pendingReview', m(Tooltip, {
        text: app.translator.trans('v17development-flarum-blog.forum.review_article.pending_review')
      }, icon('far fa-clock', {
        class: 'BlogList-item-pendingReview'
      })), 40);
    }
    return items;
  }
  dataItems() {
    var _article$user, _article$user$display;
    const article = this.attrs.article;
    const items = new ItemList();
    items.add('createdAt', m("span", {
      class: "BlogList-item-details-createdAt"
    }, icon('far fa-clock'), " ", humanTime(article.createdAt())), 100);
    items.add('author', m("span", {
      class: "BlogList-item-details-author"
    }, icon('far fa-user'), " ", ((_article$user = article.user()) == null || (_article$user$display = _article$user.displayName) == null ? void 0 : _article$user$display.call(_article$user)) || app.translator.trans('core.lib.username.deleted_text')), 80);
    items.add('replies', m("span", {
      class: "BlogList-item-details-replies"
    }, icon('far fa-comment'), " ", (article.commentCount() || 1) - 1), 60);
    return items;
  }
  contentItems() {
    var _article$blogMeta3, _article$blogMeta3$su;
    const article = this.attrs.article;
    const summary = ((_article$blogMeta3 = article.blogMeta()) == null || (_article$blogMeta3$su = _article$blogMeta3.summary) == null ? void 0 : _article$blogMeta3$su.call(_article$blogMeta3)) || '';
    const items = new ItemList();
    items.add('title', m("h4", null, this.titleItems().toArray()), 100);
    if (summary) items.add('summary', m("p", null, summary), 80);
    items.add('data', m("div", {
      class: "data"
    }, this.dataItems().toArray()), 60);
    return items;
  }
  getImage() {
    var _article$blogMeta4, _article$blogMeta4$fe;
    const _this$attrs = this.attrs,
      article = _this$attrs.article,
      defaultImage = _this$attrs.defaultImage;
    return (_article$blogMeta4 = article.blogMeta()) != null && (_article$blogMeta4$fe = _article$blogMeta4.featuredImage) != null && _article$blogMeta4$fe.call(_article$blogMeta4) ? "url(".concat(article.blogMeta().featuredImage(), ")") : defaultImage;
  }
  view(vnode) {
    var _article$blogMeta5, _article$blogMeta5$is, _article$lastReadPost;
    const _this$attrs2 = this.attrs,
      article = _this$attrs2.article,
      defaultImage = _this$attrs2.defaultImage;
    const blogImage = this.getImage();
    const isSized = (_article$blogMeta5 = article.blogMeta()) == null || (_article$blogMeta5$is = _article$blogMeta5.isSized) == null ? void 0 : _article$blogMeta5$is.call(_article$blogMeta5);
    const lastRead = (_article$lastReadPost = article.lastReadPostNumber) == null ? void 0 : _article$lastReadPost.call(article);
    let near;
    if (lastRead && lastRead > 0) {
      near = lastRead;
    }
    return m(Link, {
      href: app.route.discussion(article, near),
      className: classList('BlogList-item', {
        'BlogList-item-sized': isSized,
        'BlogList-item-default': !isSized
      }, article.tags().map(tag => "BlogList-item-category-".concat(tag.id())))
    }, m("div", {
      class: classList('BlogList-item-photo', {
        'FlarumBlog-default-image': blogImage === defaultImage
      }),
      style: {
        backgroundImage: blogImage
      }
    }), m("div", {
      class: "BlogList-item-content"
    }, this.contentItems().toArray()));
  }
}
flarum.reg.add('v17development-blog', 'forum/components/BlogOverviewItem', BlogOverviewItem);